import { useQuery } from '@tanstack/react-query';
import { fetchShipmentCargoTypesList } from '../data-provider/shipment-cargo-type';

export const useGetShipmentCargoTypes = () => {
  return useQuery({
    queryKey: ['shipment-cargo-types-list'],
    queryFn: () => fetchShipmentCargoTypesList(),
    staleTime: 1000 * 60 * 60, // 1 hour
  });
};
